import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Jodit } from 'jodit'
import 'style/jodit.css';
import isEqual from 'lodash.isequal';

class JoditEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.name || '',
      value: props.value || '',
      config: props.config || {},
      onChange: props.onChange
    };
    
    this.changeListener = this.changeListener.bind(this);
    this.createEditor = this.createEditor.bind(this);
  }

  changeListener(value) {
    this.state.value = value;
    if (typeof this.state.onChange === 'function') {
        this.state.onChange(value);
    }
  }

  componentDidMount() {
    this.createEditor();
  }

  createEditor(config = null) {
    this.editor && this.editor.destruct();
    this.editor = new Jodit(this.refs[this.state.name], config ? config : this.state.config);

    if (this.props.editorRef && typeof this.props.editorRef === 'function') {
        this.props.editorRef(this.editor);
    }

    this.editor.value = this.state.value;
    this.editor.events.on('change', this.changeListener);

    if (config) {
      this.setState({
        config
      });
    }
  }

  componentWillUnmount() {
    this.editor && this.editor.destruct();
  }

  componentDidUpdate() {
    if (!isEqual(this.state.config, this.props.config)) {
        this.createEditor(this.props.config);
    }

    if (JSON.stringify(this.editor.value) === JSON.stringify(this.props.value)) {
        return;
    }
    this.editor.value = this.props.value;
  }

  render() {
    return <textarea ref={this.state.name}></textarea>
  }
}

JoditEditor.propTypes = {
  name: PropTypes.string.isRequired,
  editorRef: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default JoditEditor;



// WEBPACK FOOTER //
// ./components/generic/JoditEditor.js